import { COLUMN_SEARCH_TYPES } from '@constants/index';

import type { OrderDirection } from './types';

export const columnSearchErrorMessages: Record<string, string> = {
  [COLUMN_SEARCH_TYPES.EMAIL]: 'Solo caracteres válidos para email',
  [COLUMN_SEARCH_TYPES.NUMBER]: 'Solo se permiten números',
  DEFAULT: 'Caracteres inválidos',
};

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T): number {
  let aValue: unknown = a[orderBy];
  let bValue: unknown = b[orderBy];

  const shortDateTimeRegex = /^\d{2}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/;
  if (
    typeof aValue === 'string' &&
    typeof bValue === 'string' &&
    shortDateTimeRegex.test(aValue) &&
    shortDateTimeRegex.test(bValue)
  ) {
    const parseShortDate = (str: string): number => {
      const [datePart, timePart] = str.split(' ');
      const [month, day, year] = datePart.split('/');
      return new Date(`20${year}-${month}-${day}T${timePart}`).getTime();
    };
    const aTime = parseShortDate(aValue);
    const bTime = parseShortDate(bValue);
    if (bTime < aTime) return -1;
    if (bTime > aTime) return 1;
    return 0;
  }

  const ddMmYyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
  if (
    typeof aValue === 'string' &&
    typeof bValue === 'string' &&
    ddMmYyyyRegex.test(aValue) &&
    ddMmYyyyRegex.test(bValue)
  ) {
    const [aDay, aMonth, aYear] = aValue.split('-');
    const [bDay, bMonth, bYear] = bValue.split('-');
    aValue = `${aYear}-${aMonth}-${aDay}`;
    bValue = `${bYear}-${bMonth}-${bDay}`;
  }

  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;
  return 0;
}

export function getComparator<T>(order: OrderDirection, orderBy: keyof T): (a: T, b: T) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number): T[] {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
